// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._1zDwii8Lx{}._1zDwii8Lx._7HhXlKQjx{padding:8px 20px}._1zDwii8Lx._7HhXlKQjx._5Bon7JcQx{padding:4px 20px}._1zDwii8Lx._7HhXlKQjx:hover{background-color:var(--ui-subtle-hover)}@media screen and (-ms-high-contrast: active){._1zDwii8Lx._7HhXlKQjx:hover{background-color:highlight}}._1zDwii8Lx._7HhXlKQjx:focus{z-index:1}._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover{background-color:var(--ui-subtle-active)}@media screen and (-ms-high-contrast: active){._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover{border-bottom:1px solid;-ms-high-contrast-adjust:none;background-color:highlight;color:window}._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox svg path,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover svg path{fill:window}._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox a,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox span,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox div,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover a,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover span,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover div{color:window}._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox button,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover button{border-color:window}._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox span::before,._1zDwii8Lx._7HhXlKQjx.vaTY9h1Ox:hover span::before{border-color:window !important}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"item": "_1zDwii8Lx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"narrow": "_7HhXlKQjx",
	"compact": "_5Bon7JcQx",
	"active": "vaTY9h1Ox"
};
module.exports = exports;
